import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import ImageListItem from '@mui/material/ImageListItem';
import CommonForm from './CommonForm';
import resetPassword from '../../assets/gifs/resetPassword.gif';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  verifyPasswordReset,
  postResetPassword,
} from '../../redux/actions/CandidateRecoveryAction';
import Verification from './Verification';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  paperStyle: {
    boxShadow: '0px 6px 22px rgba(0, 0, 0, 0.08)',
    width: '80%',
    margin: 0,
    paddingBottom: 48,
  },
}));

const ResetPassword = () => {
  const classes = useStyles();

  const passwordConditionList = [
    { expression: '(?=.*[a-z])', message: ' One small letter', state: false },
    { expression: '(?=.*[A-Z])', message: ' One capital letter', state: false },
    { expression: '(?=.*[0-9])', message: ' One number', state: false },
    {
      expression: '(?=.*[!@#$%^&*])',
      message: ' One Special character',
      state: false,
    },
    {
      expression: '(?=.{8,})',
      message: ' Must have atleast 10 characters',
      state: false,
    },
  ];
  const [validator, setValidator] = useState({});
  const location = useLocation();
  const { verificationDetails } = useSelector(
    (state) => state.candidateRecoveryState
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [passwordConditions, setPasswordConditions] = useState(
    passwordConditionList
  );
  const [credentials, setCredentials] = useState({
    newPassword: '',
    confirmPassword: '',
  });

  useEffect(() => {
    setPasswordConditions(
      passwordConditionList.map((reg) => {
        if (new RegExp(reg?.expression).test(credentials.newPassword)) {
          return { condition: reg.message, state: true };
        } else {
          return { condition: reg.message, state: false };
        }
      })
    );
  }, [credentials.newPassword]);

  useEffect(() => {
    const candidate_id = location.search?.split('=')[1];
    if (candidate_id) {
      dispatch(verifyPasswordReset({ candidate_id }));
    }
  }, []);

  const handleFormEdit = (event) => {
    setValidator({});
    const { name, value } = event.target;
    setCredentials({
      ...credentials,
      [name]: value,
    });
  };
  const checkPasswordErrors = () => {
    if (
      new RegExp('\\b([a-zA-Z0-9])\\1\\1+\\b').test(credentials.newPassword)
    ) {
      setValidator(() => ({
        inputOne: `Shouldn't contain more than two consecutive characters`,
      }));
      return true;
    }
    if (!passwordConditions?.every((condition) => condition.state)) {
      setValidator(() => ({ inputOne: `Choose a strong password` }));
      return true;
    }
    if (credentials.newPassword !== credentials.confirmPassword) {
      setValidator(() => ({ inputTwo: `Passwords didn't match` }));
      return true;
    }
    return false;
  };

  const handleReset = () => {
    if (checkPasswordErrors()) return;

    const candidate_id = location.search?.split('=')[1];
    dispatch(
      postResetPassword(
        { candidate_id, password: credentials.confirmPassword },
        navigate
      )
    );
  };

  const resetProps = {
    id: 3,
    formHeading: 'Reset Password',
    formSubHeading: 'Create a new strong password.',
    inputOneData: {
      label: 'New Password',
      type: 'password',
      name: 'newPassword',
      value: credentials.newPassword,
      onChange: handleFormEdit,
    },
    inputTwoData: {
      label: 'Confirm Password',
      type: 'password',
      name: 'confirmPassword',
      value: credentials.confirmPassword,
      onChange: handleFormEdit,
    },

    buttonName: 'Save Password',
    customStyle: classes.paperStyle,
  };
  return (
    <Grid container>
      <Grid item sm={12} md={6} textAlign='center'>
        <ImageListItem>
          <img alt='Login' src={resetPassword} />
        </ImageListItem>
      </Grid>
      <Grid item sm={12} md={5}>
        {verificationDetails?.success ? (
          <CommonForm
            {...resetProps}
            validator={validator}
            passwordConditions={passwordConditions}
            onClick={handleReset}
          />
        ) : (
          <Verification verificationDetails={verificationDetails} />
        )}
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
